<template>
  <div class="pill__num big-pulse-animation" v-if="unreadMessageCount">
    {{ unreadMessageCount }}
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'UnreadMessagesComponent',
  components: {},

  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      unreadMessageCount: 'getUserUnreadMessagesCount',
    }),
  },
  methods: {},
  watch: {},
  mounted() {
  }
};
</script>
